import { render, staticRenderFns } from "./SignUpLoginOptionModal.vue?vue&type=template&id=64b38cb6&scoped=true"
import script from "./SignUpLoginOptionModal.vue?vue&type=script&lang=js"
export * from "./SignUpLoginOptionModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpLoginOptionModal.vue?vue&type=style&index=0&id=64b38cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b38cb6",
  null
  
)

export default component.exports